import axios from "axios";
import * as config from "./config";
import {
  clearLocal,
  getLocalRefreshToken,
  setLocalAccessToken,
  statusCodes,
} from "../utils/helper";
import { Toast } from "../components/notify/Notify";

const api = axios.create({
  baseURL: config.API_URL,
});

api.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rToken = getLocalRefreshToken();
          if (!rToken) {
            return;
          }
          originalConfig.headers["x-refresh"] = rToken;
          const { newAccessToken, action } = await refreshToken(rToken);

          if (newAccessToken && action === "next") {
            api.defaults.headers.common["Authorization"] =
              "Bearer " + newAccessToken;
            setLocalAccessToken(newAccessToken);
            return api(originalConfig);
          } else if (action === "re-login") {
            // clear all localStorage
            clearLocal();
            window.location.reload();
            return Promise.reject(err);
          }
        } catch (_error) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }

      if (err.response.status === statusCodes.UNPROCESSABLE_ENTITY) {
        return Promise.reject(err);
      } else if (
        err.response.status === statusCodes.FORBIDDEN &&
        err.response.data
      ) {
        // i want to redirect to dashboard page
        window.location.href = "/forbidden";
        return Promise.reject(err);
      }
    }

    return Promise.reject(err);
  }
);

const refreshToken = async (rToken) => {
  const response = await api.post("/auth/refresh-token", {
    refreshToken: rToken,
  });
  return response.data.data;
};

export const handleErrorCreateAndUpdate = (error, callback) => {
  if (error.response.data.status === statusCodes.UNPROCESSABLE_ENTITY) {
    callback(error.response);
  } else if (error.response.data.status === statusCodes.INTERNAL_SERVER_ERROR) {
    Toast("warning", "Lỗi Máy Chủ");
  } else if (error.response.data.status === statusCodes.CONFLICT) {
    window.location.reload(true);
  } else {
    Toast("warning", error.response.data.message);
  }
};

export const handleErrorShowCache = (error) => {
  if (error.response.data.status === statusCodes.CONFLICT) {
    Toast("warning", error.response.data.message).then(function () {
      window.location.reload();
    });
  } else {
    Toast("warning", error.response.data.message);
  }
};

export default api;
